var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('font-awesome-icon',{style:({ color: _vm.color, fontSize: _vm.size }),attrs:{"icon":_vm.iconName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }